import { Box } from "../../box";
import { forwardRef, useMemo } from "react";
import { useLink } from "./useLink";
import { NewTabIndicator } from "./NewTabIndicator";
import { as, augmentElement, mergeProps, useSlots } from "../../shared";
import { useResponsiveValue, useStyleProps } from "../../styling";
import { Text } from "../../typography";
import { embeddedIconSize } from "../../icons";
import { useFormButton } from "../../form";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "a";
export function InnerTextLink(props) {
  const [styleProps] = useStyleProps("link");
  const [formProps] = useFormButton();
  const {
    active,
    as: asProp = DefaultElement,
    autoFocus,
    children,
    disabled,
    external,
    focus,
    forwardedRef,
    hover,
    rel,
    size,
    target,
    underline = "solid",
    visited,
    variant,
    ...rest
  } = mergeProps(props, styleProps, formProps);
  const sizeValue = useResponsiveValue(size);
  const {
    linkProps,
    showNewTabIndicator
  } = useLink({
    active,
    autoFocus,
    cssModule: "o-ui-text-link",
    disabled,
    external,
    focus,
    forwardedRef,
    hover,
    rel,
    target,
    underline,
    variant,
    visited
  });
  const {
    icon,
    "start-icon": startIcon,
    text
  } = useSlots(children, useMemo(() => ({
    _: {
      defaultWrapper: Text
    },
    icon: null,
    "start-icon": {
      className: "o-ui-link-start-icon",
      size: embeddedIconSize(sizeValue)
    },
    text: {
      className: "o-ui-link-text",
      size: sizeValue
    }
  }), [sizeValue]));
  const iconMarkup = icon && augmentElement(icon, {
    className: "o-ui-link-end-icon",
    size: embeddedIconSize(sizeValue)
  });
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as: asProp
    }, linkProps),
    children: [startIcon, text, iconMarkup, showNewTabIndicator && /*#__PURE__*/_jsx(NewTabIndicator, {})]
  });
}
InnerTextLink.defaultElement = DefaultElement;
export const TextLink = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTextLink, { ...props,
  forwardedRef: ref
}));
/////////
export const TextLinkAsButton = as(TextLink, "button");